import {Component, inject} from '@angular/core';
import {PageComponent, PageHeaderButtonsDirective} from '../../shared/page/page.component';
import {EntityListComponent} from '../../shared/entity-list/entity-list.component';
import {PromptsService} from '../../../services/prompts.service';
import {Observable} from 'rxjs';
import {PagedList} from '../../../models/entity.model';
import {PromptModel} from '../../../models/prompt.model';
import {RouterLink} from '@angular/router';
import {ButtonComponent} from '../../shared/button/button.component';
import {RoleService} from '../../../services/role.service';

@Component({
  selector: 'app-prompts-page',
  imports: [
    PageComponent,
    EntityListComponent,
    PageHeaderButtonsDirective,
    RouterLink,
    ButtonComponent
  ],
  templateUrl: './prompts-page.component.html',
  host: {
    class: 'app-container'
  }
})
export class PromptsPageComponent {
  private readonly promptsService = inject(PromptsService)
  protected readonly roleService = inject(RoleService)
  protected readonly prompts: Observable<PagedList<PromptModel>>

  constructor() {
    this.prompts = this.promptsService.list()
  }
}
